module.exports = "/_next/static/chromiums/twitter-512x512-index-9a80bb8d74bddf863b6b83aacb381241.jpg";